export enum AppSections {
  ALL_APPS = 'all-apps',
}
